import axios from "axios";

const SET_USER_INFO = "SET_USER_INFO";
const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";

const getName = (state) => state.username;
const getYearBirth = (state) => state.yearBirth;

const initialState = {
  username: "",
  yearBirth: "",
};

export function personalDataReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        username: action.username,
        yearBirth: action.yearBirth,
      };
    case RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}

const fetchParticipant = (id) => (dispatch, getState) => {
  const { studies } = getState().loginReducer;

  const params = {
    participantId: id,
    studyId: studies ? studies[0]?.studyId : null,
  };

  return axios
    .get(`/api/participant/contactinformation`, {
      params,
    })
    .then(({ data }) => {
      dispatch({
        type: SET_USER_INFO,
        username: data.ugnxId,
        yearBirth: data.yearOfBirth,
      });
    })
    .catch((e) => {
      dispatch({
        type: SET_USER_INFO,
        username: null,
        yearBirth: null,
      });
    });
};

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

export const mapStateToProps = (state) => {
  return {
    username: getName(state),
    yearBirth: getYearBirth(state),
  };
};

export const mapDispatchToProps = {
  fetchParticipant,
  resetState,
};
